import React, { useEffect, useState } from "react";

const LanguageSwitcher = () => {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  const toggleLanguage = () => {
    // const newLang = lang === "en" ? "ar" : "en";
    // setLang(newLang);
    // localStorage.setItem("lang", newLang);
    // window.dispatchEvent(new Event("languageChanged"));

    const newLang = lang === "en" ? "ar" : "en";
    setLang(newLang);
    localStorage.setItem("lang", newLang);
    window.dispatchEvent(new Event("languageChanged"));

    const { pathname, search, hash } = window.location;
    const isIndex = /^\/index\/?$/.test(pathname);

    if (isIndex) {
      // Reload explicitly to /index (preserve query/hash if you like)
      window.location.replace(`/index${search}${hash}`);
    } else {
      // Reload current route as-is
      window.location.reload();
    }
  };

  return (
    <li className="nav-item nav-item-box">
      <button
        className="nav-link btn btn-link p-0 d-flex align-items-center justify-content-center"
        onClick={toggleLanguage}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "8px",
          backgroundColor: "#f3f8f9",
        }}
      >
        <span style={{ fontWeight: "bold", fontSize: "16px" }}>
          {lang === "ar" ? "EN" : "ع"}
        </span>
      </button>
    </li>
  );
};

export default LanguageSwitcher;
